var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('input',{attrs:{"type":"radio"},domProps:{"checked":_vm.value == _vm.radioValue},on:{"change":function($event){return _vm.emitChange($event)}}}),_c('div',{staticClass:"radiobuttonstyle"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }